module.exports = __webpack_public_path__ + "media/icons/checkmark-in-shield-small-c96183c6.png";